import * as React from 'react';

interface OwnProps {
	isPerDiem: boolean;
}

type Props = OwnProps;

export default (props: Props) => props.isPerDiem ? <div className="sb-resource-item__per-diem-indicator" /> : null;
